var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Notifications.length > 0)?_c('v-alert',{attrs:{"type":"error"}},_vm._l((_vm.Notifications),function(message,index){return _c('div',{key:index,attrs:{"role":"alert","id":"notifications","v-model":message}},[_vm._v(" "+_vm._s(message)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }